import CornerLarge from "../../icons/CornerLarge";
import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 13 },
  { icon: CornerLarge, value: 32 },
];
